import { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ShippingCard from './ShippingCard';
import { Box, Stack, Grid, Dialog, DialogContent, Checkbox, DialogTitle, IconButton} from '@mui/material'
import { useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { createArrivals } from '../../redux/slices/arrivals';


export default function ArrivalModel({shippings=[], open, onClose}) {
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();


    
    const handleSelect = (e, id) =>{


        if(e.target.checked){
            return setSelected((s)=> [...s, id]);
        }
        return setSelected((s)=> s.filter(_id => _id !== id));
    }


    const handleCreateArrival = () =>{
        setLoading(true)
        dispatch(createArrivals(selected, ()=>{
            setLoading(false);
        }));
    }

    return (
        <Dialog open={open} maxWidth="lg">
            <DialogTitle>
                <Stack direction="row" justifyContent="flex-end">
                    <LoadingButton
                        variant="contained" 
                        color="info"
                        onClick={handleCreateArrival}
                        loading={loading}
                    >
                        Create Arrivals
                    </LoadingButton>

                    <Box sx={{ width: 50 }} />

                    <IconButton color="error" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} justifyContent="center">
                    {shippings.map((shp) =>(
                        <Grid item key={shp.id}>                      
                            <Box>
                                <Checkbox onChange={(e) => handleSelect(e, shp.id)} />
                                <ShippingCard shipping={shp}/>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    )
}
